__turbopack_context__.v({
  "clothesIcon": "styles-module__fgQVQG__clothesIcon",
  "seeSimilarItemsText": "styles-module__fgQVQG__seeSimilarItemsText",
  "wrapper": "styles-module__fgQVQG__wrapper",
});
